import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { decrementQuantity, incrementQuantity, removeFromCart } from "../components/redux/cartSlice";


const Cart = () => {
    const cart = useSelector((state) => state.cart);
    const dispatch = useDispatch();

    const totalPrice = cart
        .reduce(
            (total, item) => total + item.quantity * item.price,
            0
        )
        .toFixed(2);

    const totalItems = cart.reduce(
        (total, item) => total + item.quantity,
        0
    );

    return (
        <main className="min-h-screen px-6 py-32 md:px-12 lg:px-20">

            <div className="mx-auto max-w-[1400px]">
                
                {cart.length === 0 ? (

                    <div className="md:py-24 py-16 text-center dark:border-gray-800">

                        <div className="mx-auto max-w-xl">

                            <h2 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-white md:text-5xl">
                                Your cart is empty.
                            </h2>

                            <p className="mt-5 text-gray-500 dark:text-gray-400">
                                Looks like you haven't added anything yet.
                                Let's find something you'll love.
                            </p>

                            <Link
                                to="/products"
                                className="group mt-8 inline-flex items-center gap-3 rounded-full bg-gray-900 px-7 py-4 font-semibold text-white transition-all duration-300 hover:scale-105 hover:bg-indigo-600 dark:bg-white dark:text-black"
                            >
                                Explore Products

                                🠲
                            </Link>

                        </div>

                    </div>

                ) : (

                    <div className="grid gap-16 lg:grid-cols-[1fr_380px]">

                        {/* Products */}
                        <div>

                            <div className="border-t border-gray-200 dark:border-gray-800">

                                {cart.map((item) => {

                                    const itemTotal = (
                                        item.price * item.quantity
                                    ).toFixed(2);

                                    console.log(item.thumbnail)

                                    return (
                                        <div
                                            key={item.id}
                                            className="group border-b border-gray-200 py-8 dark:border-gray-800"
                                        >

                                            <div className="flex gap-5 md:gap-8">

                                                {/* Image */}
                                                <div className="h-28 w-28 shrink-0 overflow-hidden rounded-2xl bg-gray-100 md:h-36 md:w-36 dark:bg-gray-800">

                                                    <img
                                                        src={item.thumbnail}
                                                        alt={item.title}
                                                        className="h-full w-full object-contain p-3 transition-transform duration-500 group-hover:scale-110"
                                                    />

                                                </div>


                                                {/* Content */}
                                                <div className="flex min-w-0 flex-1 flex-col justify-between">

                                                    <div className="flex justify-between gap-4">

                                                        <h2 className="line-clamp-2 max-w-xl text-base font-bold tracking-tight text-gray-900 dark:text-white md:text-xl">
                                                            {item.title}
                                                        </h2>

                                                        <button
                                                            onClick={() =>
                                                                dispatch(
                                                                    removeFromCart(
                                                                        item.id
                                                                    )
                                                                )
                                                            }
                                                            className="shrink-0 text-gray-400 transition-colors hover:text-red-500"
                                                            aria-label={`Remove ${item.title}`}
                                                        >
                                                            🆇
                                                        </button>

                                                    </div>


                                                    <div className="mt-5 flex flex-wrap items-center justify-between gap-4">

                                                        {/* Quantity */}
                                                        <div className="flex items-center rounded-full border border-gray-200 p-1 dark:border-gray-700">

                                                            <button
                                                                onClick={() =>
                                                                    dispatch(
                                                                        decrementQuantity(
                                                                            item.id
                                                                        )
                                                                    )
                                                                }
                                                                className="flex h-8 w-8 items-center justify-center rounded-full text-gray-500 transition hover:bg-gray-100 hover:text-black dark:hover:bg-gray-800 dark:hover:text-white"
                                                            >
                                                                ⁻
                                                            </button>

                                                            <span className="w-8 text-center text-sm font-semibold">
                                                                {item.quantity}
                                                            </span>

                                                            <button
                                                                onClick={() =>
                                                                    dispatch(
                                                                        incrementQuantity(
                                                                            item.id
                                                                        )
                                                                    )
                                                                }
                                                                className="flex h-8 w-8 items-center justify-center rounded-full text-gray-500 transition hover:bg-gray-100 hover:text-black dark:hover:bg-gray-800 dark:hover:text-white"
                                                            >
                                                                ⁺
                                                            </button>

                                                        </div>


                                                        {/* Price */}
                                                        <div className="text-right">

                                                            <p className="text-xs text-gray-400">
                                                                ${item.price.toFixed(2)} each
                                                            </p>

                                                            <p className="mt-1 text-lg font-bold text-gray-900 dark:text-white">
                                                                ${itemTotal}
                                                            </p>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>
                                    );
                                })}

                            </div>

                        </div>


                        {/* Order Summary */}
                        <aside className="lg:sticky lg:top-32 lg:h-fit">

                            <div className="rounded-3xl bg-gray-100 p-7 dark:bg-gray-900 md:p-8">

                                <p className="text-sm font-medium uppercase tracking-[0.2em] text-gray-400">
                                    Order Summary
                                </p>

                                <div className="mt-8 space-y-4">

                                    <div className="flex justify-between text-gray-500">
                                        <span>Items</span>
                                        <span>{totalItems}</span>
                                    </div>

                                    <div className="flex justify-between text-gray-500">
                                        <span>Shipping</span>
                                        <span className="text-green-600">
                                            Free
                                        </span>
                                    </div>

                                </div>

                                <div className="my-6 border-t border-gray-200 dark:border-gray-700" />

                                <div className="flex items-end justify-between">

                                    <span className="font-semibold text-gray-900 dark:text-white">
                                        Total
                                    </span>

                                    <span className="text-3xl font-black tracking-tight text-gray-900 dark:text-white">
                                        ${totalPrice}
                                    </span>

                                </div>


                                <button
                                    className="group mt-8 flex w-full items-center justify-center gap-3 rounded-full bg-gray-900 px-6 py-4 font-semibold text-white transition-all duration-300 hover:scale-[1.02] hover:bg-indigo-600 dark:bg-white dark:text-black"
                                >
                                    Checkout

                                    🠲
                                </button>

                                <Link
                                    to="/products"
                                    className="mt-4 block text-center text-sm text-gray-500 transition hover:text-indigo-600"
                                >
                                    Continue Shopping
                                </Link>

                            </div>

                        </aside>

                    </div>

                )}

            </div>

        </main>
    );
};

export default Cart;